import { render, staticRenderFns } from "./TransferClass.vue?vue&type=template&id=a6209f58&scoped=true"
import script from "./TransferClass.vue?vue&type=script&lang=js"
export * from "./TransferClass.vue?vue&type=script&lang=js"
import style0 from "./TransferClass.vue?vue&type=style&index=0&id=a6209f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6209f58",
  null
  
)

export default component.exports